module.exports = __webpack_public_path__ + "static/media/carbody3.ee6553b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/carbody3.jpg
// module id = 1491
// module chunks = 0